//basic component for element 'price-element'

class PriceElement extends HTMLElement {
  constructor() {
    super();
//    this.price = this.querySelector('.price');
  //  this.currency = this.querySelector('.currency');
  }

  connectedCallback() {
    //this.updatePrice();
  }

  updatePrice() {
    const priceValue = parseFloat(this.getAttribute('data-price'));
    const currencyValue = this.getAttribute('data-currency');

    if (this.price && this.currency) {
      this.price.textContent = priceValue.toFixed(2);
      this.currency.textContent = currencyValue;
    }
  }
}
customElements.define('price-element', PriceElement);